import { api } from "roboflex-thalamus-request-handler";

export default {
    async getPAP(id) {
        try {
            const response = await api.get(`planoAcao/buscar/${id}`);
            return response.data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async listarPlanosAcao() {
        const response = await api.get("planoAcao/listar");
        return response.data;
    },

    async getFuncionalidadesUsuario(usuarioId) {
        const response = await api.get(`usuario/${usuarioId}/funcionalidades`);
        return response.data;
    },

    async atualizarPlanoAcao(id, payload) {
        await api.put(`planoAcao/atualizar/${id}`, payload);
    },

    async excluirPlanoAcao(id, usuarioId) {
        await api.put(`planoAcao/excluir/${id}`, { usuario_id: usuarioId });
    },

    async cadastrarPlanoAcao(payload) {
        const response = await api.post("planoAcao/cadastrar", payload);
        return response.data;
    },

    async atualizarPermissaoPlanoAcao(planoAcaoId, payload) {
        await api.post(`permissao/planoAcao/${planoAcaoId}`, payload);
    },
}